import { createSlice } from "@reduxjs/toolkit";

const initialState = {
   allBillingData: [],
   selectedBilling: null,
   isLoading: true,
   searchValue: "",
   searchBy: [],
   page: 0,
   dataCount: 0,
   offset: 0,
   dataPerPage: 15,
   sortField: "billingServiceID",
   sortType: "ASC",
   actionTrigger: false
};

export const BillingSlice = createSlice({
   name: "billing",
   initialState: initialState,
   reducers: {
      setBillingData: (state, action) => {
         state.allBillingData = action.payload;
      },
      billingFetched: (state, action) => {
         state.selectedBilling = action.payload;
      },
      removeSelectedBilling: (state) => {
         state.selectedBilling = null;
      },
      setSearchValue: (state, action) => {
         state.searchValue = { ...state.searchValue, ...action.payload };
      },
      setSearchBy: (state, action) => {
         state.searchBy = action.payload;
      },
      setLoading: (state, action) => {
         state.isLoading = action.payload;
      },
      setSortField: (state, action) => {
         state.sortField = action.payload;
      },
      setSortType: (state, action) => {
         state.sortType = action.payload;
      },
      setActionTrigger: (state, action) => {
         state.actionTrigger = action.payload;
      },
      setPageConfigData: (state, action) => {
         switch (action.payload.type) {
            case "SET_PAGE":
               state.page = action.payload.data;
               break;
            case "SET_DATA_COUNT":
               state.dataCount = action.payload.data;
               break;
            case "SET_IS_LOADING":
               state.isLoading = action.payload.data;
               break;
            case "SET_DATA_PER_PAGE":
               state.dataPerPage = action.payload.data;
               break;
            case "SET_OFFSET":
               state.offset = action.payload.data;
               break;
            default:
               break;
         }
      },
   },
});
